import { jsx as d, jsxs as F } from "react/jsx-runtime";
import { createContext as A, useContext as O } from "react";
import { CssBaseline as S, useMediaQuery as y } from "@mui/material";
import { createTheme as _, ThemeProvider as T, useTheme as D } from "@mui/material/styles";
const u = {
  standard: "standard",
  chat_ui: "chat-ui",
  global_head: "global-head"
}, o = {
  extra_small: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  extra_large: "xl",
  extra_extra_large: "xxl"
}, c = {
  between: "between",
  down: "down",
  not: "not",
  only: "only",
  up: "up"
}, j = "ui-suite", a = {
  primary: {
    110: "#13496D",
    100: "#1A6799",
    90: "#1D76AF",
    10: "#D3EAF8",
    5: "#E9F4FB",
    contrastText: "#FFFFFF"
  },
  secondary: {
    110: "#8B0E15",
    100: "#A21018",
    90: "#B5121B",
    10: "#FAD1D3",
    5: "#FDE8E9",
    contrastText: "#FFFFFF"
  },
  cta: {
    110: "#354F17",
    100: "#43631D",
    90: "#567F25",
    10: "#E7F4D7",
    5: "#F3F9EB",
    contrastText: "#FFFFFF"
  },
  warning: {
    110: "#AE3805",
    100: "#C13E05",
    90: "#D44406",
    10: "#6C9F2E",
    5: "#FEEDE6",
    contrastText: "#FFFFFF"
  },
  grey: {
    100: "#0D0D0D",
    90: "#1A1A1A",
    80: "#333333",
    70: "#4D4D4D",
    60: "#666666",
    50: "#808080",
    40: "#999999",
    30: "#B3B3B3",
    20: "#CCCCCC",
    10: "#E6E6E6",
    5: "#F2F2F2",
    0: "#FFFFFF"
  }
};
function M(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var B = function(r) {
  return I(r) && !P(r);
};
function I(e) {
  return !!e && typeof e == "object";
}
function P(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || N(e);
}
var C = typeof Symbol == "function" && Symbol.for, v = C ? Symbol.for("react.element") : 60103;
function N(e) {
  return e.$$typeof === v;
}
function k(e) {
  return Array.isArray(e) ? [] : {};
}
function l(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? i(k(e), e, r) : e;
}
function R(e, r, t) {
  return e.concat(r).map(function(s) {
    return l(s, t);
  });
}
function V(e, r) {
  if (!r.customMerge)
    return i;
  var t = r.customMerge(e);
  return typeof t == "function" ? t : i;
}
function $(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(r) {
    return Object.propertyIsEnumerable.call(e, r);
  }) : [];
}
function f(e) {
  return Object.keys(e).concat($(e));
}
function b(e, r) {
  try {
    return r in e;
  } catch {
    return !1;
  }
}
function Q(e, r) {
  return b(e, r) && !(Object.hasOwnProperty.call(e, r) && Object.propertyIsEnumerable.call(e, r));
}
function U(e, r, t) {
  var s = {};
  return t.isMergeableObject(e) && f(e).forEach(function(n) {
    s[n] = l(e[n], t);
  }), f(r).forEach(function(n) {
    Q(e, n) || (b(e, n) && t.isMergeableObject(r[n]) ? s[n] = V(n, t)(e[n], r[n], t) : s[n] = l(r[n], t));
  }), s;
}
function i(e, r, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || R, t.isMergeableObject = t.isMergeableObject || B, t.cloneUnlessOtherwiseSpecified = l;
  var s = Array.isArray(r), n = Array.isArray(e), g = s === n;
  return g ? s ? t.arrayMerge(e, r, t) : U(e, r, t) : l(r, t);
}
i.all = function(r, t) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(s, n) {
    return i(s, n, t);
  }, {});
};
var K = i, L = K;
const Y = /* @__PURE__ */ M(L), G = {
  primary: {
    main: a.primary[110],
    light: a.primary[100],
    dark: a.primary[90],
    ...a.primary
  },
  secondary: {
    main: a.secondary[110],
    light: a.secondary[100],
    dark: a.secondary[90],
    ...a.secondary
  },
  success: {
    main: a.cta[110],
    light: a.cta[100],
    dark: a.cta[90],
    ...a.cta
  },
  grey: {
    900: a.grey[100],
    800: a.grey[90],
    700: a.grey[80],
    600: a.grey[70],
    500: a.grey[60],
    400: a.grey[50],
    300: a.grey[40],
    200: a.grey[30],
    100: a.grey[20],
    50: a.grey[10],
    A100: a.grey[0],
    ...a.grey
  },
  warning: {
    main: a.warning[110],
    light: a.warning[100],
    dark: a.warning[90],
    ...a.warning
  }
}, H = {
  fontFamily: "myriad-pro, sans-serif"
}, q = {
  [o.extra_small]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [o.small]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [o.medium]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [o.large]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [o.extra_large]: {
    columns: {
      full: "1152px",
      gutter: "24px",
      3: "270px"
    }
  },
  [o.extra_extra_large]: {
    columns: {
      full: "1288px",
      gutter: "32px",
      3: "298px"
    }
  }
}, z = [
  "none",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.45)",
  "0px 2px 4px 0px rgba(26, 26, 26, 0.16)",
  "0px 2px 4px 0px rgba(26, 26, 26, 0.24)",
  "0px 4px 4px 0px rgba(26, 26, 26, 0.24)",
  "0px 4px 4px 0px rgba(26, 26, 26, 0.32)"
], W = {
  ribbon: 1250
}, J = {
  borderRadius: "10px",
  gridVertical: "0.5rem",
  letterBetween: "0rem",
  lineHeight: "130%"
}, X = [
  "none",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.08)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.16)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.24)",
  "0px 8px 16px 0px rgba(26, 26, 26, 0.32)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.4)"
], p = {
  values: {
    [o.extra_small]: 0,
    [o.small]: 576,
    [o.medium]: 768,
    [o.large]: 992,
    [o.extra_large]: 1200,
    [o.extra_extra_large]: 1440
  }
}, Z = (e) => ({
  [u.global_head]: p,
  [u.standard]: p
})[e] ?? p, ee = (e) => ({
  typography: H,
  palette: G,
  spacing: (r) => `${r * 8}px`,
  shadows: z,
  zIndex: W,
  customSpacing: J,
  customBoxShadowInner: X,
  breakpoints: {
    ...Z(e),
    contentGrids: q
  }
}), re = (e, r = {}, t = !1) => {
  if (!e)
    throw new Error("The appName must be provided!");
  const s = Object.keys(r).length === 0 || t ? ee(e) : {}, n = Y(s, r);
  return _({
    cssVariables: !0,
    cssVarPrefix: j,
    ...n
  });
}, x = A(), le = ({
  children: e,
  theme: r,
  appName: t = u.standard,
  shouldMergeWithBaseTheme: s = !1
}) => {
  const n = re(t, r, s);
  return /* @__PURE__ */ d(x.Provider, { value: t, children: /* @__PURE__ */ F(T, { theme: n, children: [
    /* @__PURE__ */ d(S, {}),
    e
  ] }) });
}, te = () => {
  const e = O(x);
  if (!e)
    throw new Error("useAppName must be used within a DesignSystemProvider");
  return e;
}, ne = (e, r, t) => {
  if (!Object.values(c).includes(e))
    throw new Error(`Invalid method "${e}"`);
  if (!Array.isArray(r) || r.length === 0)
    throw new Error('The "values" array must contain at least one breakpoint');
  for (const s of r)
    if (s === void 0 || !Object.keys(t).includes(s))
      throw new Error(`Invalid breakpoint "${s}"`);
  if (e === c.between) {
    if (r.length !== 2)
      throw new Error('The "between" method requires two values');
    const [s, n] = r;
    if (t[s] > t[n])
      throw new Error("The first breakpoint cannot be greater than the second breakpoint");
  }
};
function ue({
  method: e = null,
  values: r = null,
  defaultDesktopBreakpoint: t = o.large
}) {
  let s;
  const n = D(), h = te() === u.global_head ? o.extra_large : t;
  e && r && (ne(e, r, n.breakpoints.values), s = (() => {
    const [m, w] = r;
    switch (e) {
      case c.up:
      case c.down:
      case c.only:
      case c.not:
        return n.breakpoints[e](m);
      case c.between:
        return n.breakpoints.between(m, w);
      default:
        throw new Error(`Unsupported method "${e}"`);
    }
  })());
  const E = () => y(n.breakpoints.up(h), { noSsr: !0 });
  return {
    matches: s ? y(s, { noSsr: !0 }) : null,
    isDesktop: E,
    // As it is just for demo purposes, we don't need to compute these values in here.
    themeBreakpoints: () => n.breakpoints.values
  };
}
const pe = (e) => {
  if (typeof e != "string" || !e.trim().startsWith("--"))
    throw new Error("Invalid CSS variable name");
  return typeof window < "u" && getComputedStyle(document.body).getPropertyValue(e.trim()) || null;
};
export {
  u as APP_NAMES,
  c as BREAKPOINT_AVAILABLE_QUERY_METHODS,
  o as BREAKPOINT_DIMENSIONS,
  j as DESIGN_SYSTEM_NAME,
  le as DesignSystemProvider,
  a as PALETTE,
  re as createCustomTheme,
  Z as getBreakpointsByAppName,
  pe as getCssVar,
  ee as getDefaultTheme,
  te as useAppName,
  ue as useMediaQuery
};
